/**
 * useWebBackToClose — Sur web, le bouton "back" du navigateur ferme
 * un modal RN Modal au lieu de quitter l'application.
 *
 * Usage :
 *   import useWebBackToClose from '../hooks/useWebBackToClose';
 *   useWebBackToClose(visible, onClose);
 *
 * v1.12.568 — créé pour rendre la navigation web moins choquante.
 */
import { useEffect } from 'react';
import { Platform } from 'react-native';

export default function useWebBackToClose(visible, onClose) {
  useEffect(() => {
    if (Platform.OS !== 'web' || !visible) return undefined;
    if (typeof window === 'undefined' || !window.history) return undefined;
    const marker = `rnModal_${Date.now()}_${Math.random().toString(36).slice(2, 6)}`;
    try { window.history.pushState({ rnModal: marker }, '', window.location.href); } catch {}
    let closedByPopstate = false;
    const onPop = () => { closedByPopstate = true; try { onClose && onClose(); } catch {} };
    window.addEventListener('popstate', onPop);
    return () => {
      window.removeEventListener('popstate', onPop);
      if (!closedByPopstate) {
        try {
          if (window.history.state?.rnModal === marker) window.history.back();
        } catch {}
      }
    };
  }, [visible, onClose]);
}
